import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  parentIndex: number;
}

export default function ActivitySaleGuestTable(props: Props) {
  const { t } = useTranslation();

  const name = `approvalable.activitySales.${props.parentIndex}.activitySaleGuests`;

  const _value = HOCWatchValue({
    keys: [name],
  });
  const value = _value[name];

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:guest_preferences'),
      accessorKey: 'guestPreferences',
      minSize: 100,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
    {
      header: t('guest:booking_preferences'),
      accessorKey: 'preferences',
      minSize: 250,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
